import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useBlacklistOptions = () => {
  const { t } = useTranslation();
  const [blacklist, setBlacklist] = useState();

  const defaultValues = [
    { label: t('CUSTOMERS.blacklisted'), value: true },
    { label: t('CUSTOMERS.notBlacklisted'), value: false },
  ];

  if (!blacklist) {
    setBlacklist(defaultValues);
  }
  return blacklist;
};

export { useBlacklistOptions };
